"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _reactDom = require("react-dom"),
    _lodash = _interopRequireDefault(require("lodash.isequal")),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit"),
    _reactTransitionGroup = require("react-transition-group"),
    _lodash2 = _interopRequireDefault(require("lodash.memoize"));

require("animate.css");

var _lodash3 = _interopRequireDefault(require("lodash.get")),
    _reactStickyMouseTooltip = _interopRequireDefault(require("react-sticky-mouse-tooltip")),
    _CommentButton = _interopRequireDefault(require("./CommentButton")),
    _CommentPopover = _interopRequireDefault(require("../../CommentPopover")),
    _Indicators = _interopRequireDefault(require("./Indicators"));

require("../styles/_comments-overlay.scss");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var COMMENT_THRESHOLD_MS = .5,
    CLOSE_MODAL_ORIGIN = "comments-overlay",
    CommentsOverlay = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.handleClickComment = (0, _lodash2["default"])(function (a) {
      return function () {
        var b = d.props,
            c = b.showCommentModal,
            e = b.onAddComment,
            f = b.onDeleteComment,
            g = b.commentModalId,
            h = b.closePopover,
            i = b.closeModalOrigin,
            j = a.commentId;
        return !g && i && i !== CLOSE_MODAL_ORIGIN || g === j ? void h({
          closeModalOrigin: CLOSE_MODAL_ORIGIN
        }) : void c(j, {
          onOuterAction: d.onPopoverOuterAction,
          onAddComment: e,
          onDeleteComment: f
        });
      };
    }), d.onMouseOver = function (a) {
      var b = a.target,
          c = d.state.tooltipVisible,
          e = (0, _lodash3["default"])(d._overlay, "current") && b && d._overlay.current === b;
      c || !e || d.setState({
        tooltipVisible: !0
      });
    }, d.onMouseOut = function (a) {
      var b = a.target,
          c = (0, _lodash3["default"])(d._overlay, "current") && b && d._overlay.current === b,
          e = d.state.tooltipVisible;
      c && e && d.setState({
        tooltipVisible: !1
      });
    }, d.onPopoverOuterAction = function (a) {
      var b = d.props.closePopover,
          c = document.querySelector(".comment-button--selected");
      c && !c.contains(a.target) && b({
        closeModalOrigin: CLOSE_MODAL_ORIGIN
      });
    }, d.getSelectableComments = function () {
      var a = d.props,
          b = a.time,
          c = a.comments;
      return c.filter(function (a) {
        var c = a.timestamp,
            d = a.commentId;
        return d && b <= c + COMMENT_THRESHOLD_MS && b >= c - COMMENT_THRESHOLD_MS;
      });
    }, d.moveToComment = function (a) {
      var b = d.props,
          c = b.pauseTime,
          e = b.comments,
          f = b.setCustomTime,
          g = d.state.newComment;

      if (!g) {
        d._paused = !0, c();
        var h = e.find(function (b) {
          return b.commentId === a;
        });
        h && f(h.timestamp);
      }
    }, d.handleModalClose = function () {
      d.disableOverlay(), d.setState({
        newComment: void 0
      });
    }, d.disableOverlay = function () {
      d._isOverlayDisabled = !0, setTimeout(function () {
        d._isOverlayDisabled = !1;
      }, 200);
    }, d.handlePlaying = function () {
      var a = d.state.visibleComments;
      d._paused = !1;
      var b = d.getSelectableComments();
      return (0, _lodash["default"])(a, b) ? void 0 : void d.setState({
        visibleComments: b
      });
    }, d.onOverlayClick = function (a) {
      if (!d._isOverlayDisabled) {
        var b = d.props,
            c = b.pauseTime,
            e = b.time,
            f = b.getUserColor,
            g = b.comments,
            h = b.showCommentModal,
            i = b.onAddComment,
            j = b.selectedClip,
            k = void 0 === j ? {} : j,
            l = b.assetId,
            m = b.commentModalId,
            n = document.querySelector(".comments-overlay");

        if (n && !m) {
          c();

          var o = n.getBoundingClientRect(),
              p = o.left,
              q = o.top,
              r = o.width,
              s = o.height,
              t = p + r - 55,
              u = p + 5,
              v = a.clientX - p - 25,
              w = v < u ? u : v,
              x = v > t ? t : w,
              y = a.clientY - q - 25,
              z = 5 > y ? 5 : y,
              A = (100 * (x / r)).toFixed(0),
              B = (100 * (z / s)).toFixed(0),
              C = Date.now().toString(),
              D = k.clipId,
              E = k.clipStartTime,
              F = void 0 === E ? 0 : E,
              G = _objectSpread({
            xPercent: parseInt(A, 10),
            yPercent: parseInt(B, 10),
            timestamp: e
          }, D ? {
            clipId: D,
            clipCommentTime: e - F
          } : {
            assetId: l
          }),
              H = _objectSpread({
            id: C,
            colour: f(),
            number: g.length + 1
          }, G);

          d.setState({
            newComment: H
          }, function () {
            h(C, {
              onAddComment: i,
              metadata: G,
              onOuterAction: d.onPopoverOuterAction
            });
          });
        }
      }
    }, d.renderComment = function (a) {
      var b = a.comment,
          c = a.commentModalId;
      return _react["default"].createElement(_reactTransitionGroup.CSSTransition, {
        key: b.commentId,
        classNames: {
          enter: "animated",
          enterActive: "bounceIn",
          exit: "animated",
          exitActive: "bounceOut"
        },
        timeout: 600
      }, _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_CommentButton["default"], (0, _extends2["default"])({
        onClick: d.handleClickComment(b),
        selected: c === b.commentId
      }, b)), _react["default"].createElement(_CommentPopover["default"], {
        id: b.commentId || b.id,
        commentId: b.commentId
      }, _react["default"].createElement("div", {
        style: {
          height: "50px",
          width: "50px",
          position: "absolute",
          left: "".concat(b.xPercent, "%"),
          top: "".concat(b.yPercent, "%")
        }
      }))));
    }, d.state = {
      visibleComments: d.getSelectableComments(),
      tooltipVisible: !1
    }, d._overlay = _react["default"].createRef(), d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(a) {
      var b = this.props,
          c = b.time,
          d = b.comments,
          e = b.commentModalId;
      e || !a.commentModalId || this.handleModalClose(), a.time === c && (this._paused = !0), (a.time !== c || a.comments !== d) && this.handlePlaying(), e && a.commentModalId !== e && this.moveToComment(e);
    }
  }, {
    key: "render",
    value: function render() {
      var a = this,
          b = this.props,
          c = b.className,
          d = b.selector,
          e = b.totalDuration,
          f = b.commentsOverlayClass,
          g = b.isReadOnly,
          h = b.comments,
          i = b.commentModalId,
          j = b.hideIndicators,
          k = this.state,
          l = k.visibleComments,
          m = k.newComment,
          n = k.tooltipVisible,
          o = document.querySelector(d);
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("comments-overlay", c)
      }, _react["default"].createElement(_reactStickyMouseTooltip["default"], {
        visible: n,
        offsetX: 15
      }, _react["default"].createElement(_uiKit.Text, {
        noMargin: !0,
        darkTheme: !0,
        label: !0,
        className: "comments-overlay__tooltip"
      }, "Click to leave a comment")), !j && o && (0, _reactDom.createPortal)(_react["default"].createElement(_Indicators["default"], {
        comments: h,
        totalDuration: e,
        className: (0, _classnames["default"])("comments-overlay__comments", f),
        onClickIndicator: this.handleClickComment
      }), o), _react["default"].createElement(_reactTransitionGroup.TransitionGroup, {
        component: null
      }, l.map(function (b) {
        return a.renderComment({
          comment: b,
          commentModalId: i
        });
      })), m ? this.renderComment({
        comment: m
      }) : null, g ? null : _react["default"].createElement("button", {
        type: "button",
        className: "comments-overlay__interactive",
        onClick: this.onOverlayClick,
        ref: this._overlay,
        onMouseOver: this.onMouseOver,
        onMouseOut: this.onMouseOut,
        onFocus: this.onMouseOver,
        onBlur: this.onMouseOut
      }));
    }
  }]), b;
}(_react.Component);

exports["default"] = CommentsOverlay;